/**
 * Highlight the creator and link to their profiles.
 */
export const CreatorBanner = () => {
	return (
		<section className="creator">
			<div className="creator-inner">
				<div>
					<div className="kicker">◉ Made by</div>
					<h2>
						Andrew <em>Byrd.</em>
					</h2>
					<p>
						Hello. I'm a web developer who has found himself time to create all
						the stupid side projects he's wanted to create with the help of AI.
						This is one of them. Please follow me on X, Github, or check out my
						personal site.
					</p>
				</div>

				<div className="creator-links">
					<a
						className="creator-link"
						href="https://abyrd.me"
						target="_blank"
						rel="noopener noreferrer"
					>
						<div>
							<span className="cl-label">Personal site</span>
							<span className="cl-val">abyrd.me</span>
						</div>
						<span className="cl-arrow">↗</span>
					</a>
					<a
						className="creator-link github-link"
						href="https://github.com/Abyrd9"
						target="_blank"
						rel="noopener noreferrer"
					>
						<div>
							<span className="cl-label">GitHub</span>
							<span className="cl-val">@Abyrd9</span>
						</div>
						<span className="cl-arrow">↗</span>
					</a>
					<a
						className="creator-link x-link"
						href="https://x.com/Abyrd_9"
						target="_blank"
						rel="noopener noreferrer"
					>
						<div>
							<span className="cl-label">Follow on X</span>
							<span className="cl-val">@Abyrd_9</span>
						</div>
						<span className="cl-arrow">↗</span>
					</a>
				</div>
			</div>
		</section>
	);
};
